import type { StateCreator } from 'zustand';
import type { PatientTabsSliceType } from '../types';
import { getVisibleIds } from '../utils/getVisibleIds';

export const initializeTabs: StateCreator<
  PatientTabsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  PatientTabsSliceType['initializeTabs']
> = (set) => (tabs, initialTabId) => {
  const visibleIds = getVisibleIds(tabs);
  const targetIndex = initialTabId ? visibleIds.findIndex((id) => id === initialTabId) : -1;
  const initialIndex = targetIndex >= 0 ? targetIndex : 0;

  set(
    (state) => {
      state.patientTabs.tabs = tabs;
      state.patientTabs.activeTabIndex = initialIndex;
    },
    false,
    'patientTabs/initializeTabs',
  );
};
